<template>
    <rkm-modal
        large
        ref="RkmModal"
        title="Centro de custo"
    >
        <rkm-form
            ref="RkmForm"
            show-legend
        >
            <rkm-row>
                <rkm-col>
                    <rkm-form-select
                        :options="form.centrosCusto"
                        :validations="validations.centroCusto"
                        label="Setor"
                        show-default-option
                        text-field="nome"
                        v-model="model.centroCustoId"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col cols="auto">
                    <rkm-button
                        :label="false"
                        @click="include"
                        color="primary"
                    >
                        Incluir
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <rkm-table
            :fields="fields"
            :items="model.centrosCusto"
        >
            <template v-slot:cell(actions)="{item}">
                <rkm-button
                    @click="destroy(item)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>

        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>

            <rkm-button
                @click="save"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Mixins.
import {error, object, repository, stringCase} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

export default {
    computed: {
        validations() {
            return {
                centroCusto: {required: true},
            }
        },
    },
    created() {
        this.repositories = {
            usuario: this.getConectaSusRepository('cadastro.sujeitoAtencao.usuario')
        }
    },
    data: () => ({
        form: {
            centrosCusto: [],
        },
        fields: [
            {key: 'nome', label: 'Setor', sortable: true},
            {class: 'col-min', key: 'actions', label: 'Ações'},
        ],
        item: null,
        lotacao: null,
        model: {
            centroCustoId: null,
            centrosCusto: [],
        },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(item) {
            this.reset()

            this.item = item
            this.model.centrosCusto = this.clone(item.centrosCusto)

            this.load(item.infraestruturaId)

            this.$refs.RkmModal.show()
        },
        load(infraestruturaId) {
            this.setLoading()

            const request = {infraestruturaId}

            this.repositories.usuario.getCentrosCusto(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => this.form.centrosCusto = response.data)
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        include() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    if (this.model.centrosCusto && this.model.centrosCusto.find(centroCusto => centroCusto.id === this.model.centroCustoId)) {
                        this.showValidationNotification('O setor já foi incluído.')
                        return
                    }

                    const centroCusto = this.form.centrosCusto.find(centroCusto => centroCusto.id === this.model.centroCustoId)

                    this.model.centrosCusto.push(centroCusto)

                    this.reset()
                })
        },
        destroy(index) {
            this.showDeleteConfirmation('Deseja realmente excluir o setor?', async () => {
                this.model.centrosCusto.splice(index, 1)
            })
        },
        save() {
            this.item.centrosCusto = this.model.centrosCusto
            this.$refs.RkmModal.hide()
        },
        reset() {
            this.model.centroCustoId = null
            this.$nextTick().then(() => this.$refs.RkmForm.resetValidator())
        },
    },
    mixins: [error, object, repository, stringCase],
}
</script>